module.exports = __webpack_public_path__ + "static/img/_82A3641.f449cd8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sustainable/_82A3641.jpg
// module id = AwKm
// module chunks = 0